import ExternalLinkOpener from "./ExternalLinkOpener";
import { useLocation, Link } from "react-router-dom";

export default function Header({ data }) {
  const location = useLocation();

  // Helper to resolve logo paths – keeps them absolute from the domain root
  const resolveLogoPath = (path) => {
    if (!path) return "";
    if (path.startsWith("http") || path.startsWith("/")) return path;
    // Add leading slash to make it absolute from domain root
    return `/${path}`;
  };

  return (
    <header className="w-full border-b border-primary-100 shadow-sm bg-white">
      <div className="max-w-7xl mx-auto flex flex-row flex-wrap items-center justify-center gap-y-2 gap-x-2 xs:gap-x-4 md:gap-x-28 px-1 xs:px-2 md:px-8 py-2 md:py-4">
        {/* Left Logo */}
        <a
          href="https://www.india.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
          title="National Portal of India"
          aria-label="State Emblem of India"
          className="flex items-center"
        >
          {data.national_logo && (
            <img
              src={resolveLogoPath(data.national_logo)}
              alt="State Emblem of India"
              className="h-8 xs:h-8 sm:h-10 md:h-12 lg:h-20 object-contain"
            />
          )}
        </a>

        {/* Title & Branding for Print/Web */}
        <Link to="/" className="flex flex-col items-center hover:opacity-90 transition-opacity no-underline" aria-label="Go to Home - Employment News">
          {location.pathname === "/" ? (
            <h1 className="sr-only">Employment News</h1>
          ) : (
            <div className="sr-only">Employment News</div>
          )}
          {data.logo && (
            <img
              src={resolveLogoPath(data.logo)}
              alt="Employment News Logo"
              className="h-8 xs:h-8 sm:h-10 md:h-12 lg:h-20 object-contain print:h-[60pt]"
            />
          )}
        </Link>

        {/* Right Logo */}
        <ExternalLinkOpener
          url="https://www.publicationsdivision.nic.in/"
          text={
            data.publication_logo && (
              <img
                src={resolveLogoPath(data.publication_logo)}
                alt="Publications Division"
                className="h-6 xs:h-7 sm:h-8 md:h-10 lg:h-[4.75rem] object-contain"
              />
            )
          }
        />
      </div>
    </header>
  );
}
